import script from "./AiSkelaton.vue?vue&type=script&setup=true&lang=js"
export * from "./AiSkelaton.vue?vue&type=script&setup=true&lang=js"

import "./AiSkelaton.vue?vue&type=style&index=0&id=8051eb32&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8051eb32"]])

export default __exports__